import React from 'react';
import { useHistory } from 'react-router-dom';
import TotalsAnalyseSampleList from '../../components/TotalsAnalyseSampleList';


const TotalsAnalyseSample = () => {
    const history = useHistory();

    return (
            <TotalsAnalyseSampleList/>
    );
}

export default TotalsAnalyseSample;
